(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["power-calculator"] && !Shopify.designMode) return;
  try {
    
  class PowerCalculator extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.result = this.querySelector('[data-result]');
      this.detail = this.querySelector('[data-detail]');
      this.form.addEventListener('input', () => this.update());
      this.form.addEventListener('submit', (event) => event.preventDefault());
      this.update();
    }

    update() {
      const f = this.form.elements;
      const surface = parseFloat(String(f.surface.value).replace(',', '.'));
      const height = parseFloat(String(f.height.value).replace(',', '.'));
      const ratio = parseFloat(this.dataset[f.insulation.value]);
      const max = parseInt(this.dataset.max, 10) || 2000;

      const valid =
        surface >= parseFloat(f.surface.min) && surface <= parseFloat(f.surface.max) &&
        height >= parseFloat(f.height.min) && height <= parseFloat(f.height.max) &&
        ratio > 0;
      if (!valid) {
        this.result.textContent = '–';
        this.detail.textContent = this.dataset.invalid;
        return;
      }

      // Besoin en watts = volume (m³) × coefficient d'isolation
      const need = surface * height * ratio;
      // Puissances vendues, jamais au-delà du maximum par radiateur
      const sizes = [500, 750, 1000, 1250, 1500, 2000].filter((w) => w <= max);
      const biggest = sizes[sizes.length - 1];
      // Nombre minimum de radiateurs pour ne jamais dépasser le maximum ;
      // on compare avec un radiateur de plus et on garde la puissance totale
      // la plus proche du besoin, seulement si l'écart dépasse 500 W
      const minCount = Math.ceil(need / biggest);
      let count = minCount;
      let power = sizes.find((w) => w * minCount >= need);
      if (minCount > 1) {
        const altPower = sizes.find((w) => w * (minCount + 1) >= need);
        if (power * minCount - altPower * (minCount + 1) >= 500) {
          count = minCount + 1;
          power = altPower;
        }
      }

      if (count === 1) {
        this.result.textContent = `${this.format(power)} W`;
        this.detail.textContent = this.dataset.single;
      } else {
        this.result.textContent = `${count} × ${this.format(power)} W`;
        this.detail.textContent = this.dataset.split
          .replace('[count]', count)
          .replace('[power]', this.format(power))
          .replace('[total]', this.format(count * power));
      }
    }

    format(value) {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr').format(value);
    }
  }

  if (!customElements.get('power-calculator')) {
    customElements.define('power-calculator', PowerCalculator);
  }

  } catch(e) { console.error(e); }
})();
})();
